import styled from 'styled-components';
import { Typography } from 'components/generic/typography';
import type { LabelProps } from 'components/generic/typography/components/Label';

const StyledLabel = styled(Typography.Label)`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export default function Variant({ ...restProps }: LabelProps) {
    const { children } = restProps;

    return <StyledLabel {...restProps}>{children}</StyledLabel>;
}
